import { useEffect, useMemo, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { connect } from "react-redux";
// @material-ui/core components
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { useLocation } from "react-router-dom";

import componentStylesGeneric from "assets/theme/views/admin/generic.js";
import LocationHeader from "components/Headers/LocationHeader";
import { getIsOpportunityApplicationAction } from "redux/actions/opportunitiesAction";
import { PAGINATION } from "utils/const";
import OpportunityApplicationsFilterSection from "./Sections/OpportunityApplicationsFilterSection";
import OpportunityApplicationsResultSection from "./Sections/OpportunityApplicationsResultSection";

const useStylesGeneric = makeStyles(componentStylesGeneric);

function OpportunityApplicationsList(props) {
  const classes = useStylesGeneric();
  const location = useLocation();
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");

  const defaultFormValues = useMemo(
    () => ({
      applicationCode: "",
      opportunityType: null,
      searchText: "",
      applicationState: null,
      opportunityReference: "",
      userNameOrIdentityCard: "",
      pageIndex: PAGINATION.FIRST_PAGE,
      pageSize: PAGINATION.PAGE_SIZE,
    }),
    []
  );

  // Se a URL já tem query params, evita disparar busca com defaults.
  // O useFilterSync vai aplicar a URL no form e então liberamos a busca.
  const hasInitialSearchParams = (location.search || "") !== "";
  const [filtersReady, setFiltersReady] = useState(!hasInitialSearchParams);

  const form = useForm({
    mode: "onChange",
    defaultValues: defaultFormValues,
  });

  const setIsOpportunityApplication = () => {
    props.getIsOpportunityApplication(true);
  };
  
  useEffect(() => {
    setIsOpportunityApplication();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  return (
    <Grid container classes={{ root: classes.containerRoot }}>
      <LocationHeader
        section="Lista de Candidaturas"
      />
      <FormProvider {...form}>
        <Grid item xs={12} md={12}>
          <OpportunityApplicationsFilterSection
            sortColumn={sortColumn}
            sortDirection={sortDirection}
            defaultFormValues={defaultFormValues}
            filtersReady={filtersReady}
            setFiltersReady={setFiltersReady}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <Box classes={{ root: classes.tableResultBoxRoot }}>
            <OpportunityApplicationsResultSection
              sortColumn={sortColumn}
              setSortColumn={setSortColumn}
              sortDirection={sortDirection}
              setSortDirection={setSortDirection}
            />
          </Box>
        </Grid>
      </FormProvider>
    </Grid>
  );
}

const mapStateToProps = (state) => ({ ...state });

const mapDispatchToProps = (dispatch) => ({
  getIsOpportunityApplication: (isOpportunityApplication) => dispatch(getIsOpportunityApplicationAction(isOpportunityApplication)),
});


export default connect(mapStateToProps, mapDispatchToProps)(OpportunityApplicationsList);